import React from 'react';

const Footer = () => {
    return (
        <div>
            <h6 className="text-center">© Designed & developed by Md. Omar Faruke</h6>
        </div>
    );
};

export default Footer;